import React from 'react';
import { ShieldCheck, Database } from 'lucide-react';

const SecuritySection = ({
  formData,
  handleInputChange,
  errors,
  dataComplexityLevels,
  securityLevels
}) => {
  return (
    <div className="mb-6 bg-green-50 dark:bg-green-900/20 p-4 rounded-lg border border-green-200 dark:border-green-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <ShieldCheck className="w-5 h-5 mr-2 text-green-500" />
        Сложность и безопасность данных
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Сложность данных */}
        <div>
          <label htmlFor="dataComplexity" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Database className="w-4 h-4 mr-2 text-green-500" />
            Сложность данных
          </label>
          <select
            id="dataComplexity"
            name="dataComplexity"
            value={formData.dataComplexity}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.dataComplexity ? 'input-error' : ''}`}
          >
            {dataComplexityLevels.map((level) => (
              <option key={level.id} value={level.id}>
                {level.name}
              </option>
            ))}
          </select>
          {errors.dataComplexity && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.dataComplexity}
            </p>
          )}
          {formData.dataComplexity && (
            <p className="mt-1 text-xs text-gray-600 dark:text-gray-400">
              {dataComplexityLevels.find(d => d.id === formData.dataComplexity)?.description || ''}
            </p>
          )}
        </div>

        {/* Уровень безопасности */}
        <div>
          <label htmlFor="securityLevel" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <ShieldCheck className="w-4 h-4 mr-2 text-green-500" />
            Уровень безопасности
          </label>
          <select
            id="securityLevel"
            name="securityLevel"
            value={formData.securityLevel}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.securityLevel ? 'input-error' : ''}`}
          >
            {securityLevels.map((level) => (
              <option key={level.id} value={level.id}>
                {level.name}
              </option>
            ))}
          </select>
          {errors.securityLevel && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.securityLevel}
            </p>
          )}
          {formData.securityLevel && (
            <p className="mt-1 text-xs text-gray-600 dark:text-gray-400">
              {securityLevels.find(s => s.id === formData.securityLevel)?.description || ''}
            </p>
          )}
        </div>
      </div>

      <div className="mt-4 bg-green-100 dark:bg-green-900/30 p-3 rounded-lg border border-green-200 dark:border-green-800">
        <div className="flex items-start">
          <ShieldCheck className="w-5 h-5 text-green-600 dark:text-green-400 mr-3 mt-1" />
          <div>
            <h4 className="text-sm font-medium text-green-700 dark:text-green-300 mb-1">
              Рекомендации по безопасности
            </h4>
            <p className="text-xs text-green-600 dark:text-green-400">
              {formData.securityLevel === 'advanced' 
                ? 'Продвинутый уровень безопасности включает шифрование данных, многофакторную аутентификацию, детальное логирование и мониторинг активности.' 
                : formData.securityLevel === 'standard' 
                ? 'Стандартный уровень обеспечивает базовое шифрование, контроль доступа и основные механизмы аудита.' 
                : 'Базовый уровень включает только необходимый минимум защиты данных. Не рекомендуется для чувствительной информации.'}
              {formData.dataComplexity === 'high' && ' При работе с высоко сложными данными рекомендуется повысить уровень безопасности.'}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecuritySection;